export default __webpack_public_path__ + "static/media/mg.ab232143.png";